/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Article } from '../../models/article';

export interface ApiMasterArticleGetByIdGet$Params {
  id?: string;
}

export function apiMasterArticleGetByIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterArticleGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Article>> {
  const rb = new RequestBuilder(rootUrl, apiMasterArticleGetByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Article>;
    })
  );
}

apiMasterArticleGetByIdGet.PATH = '/api/Master/Article/GetById';
